"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeliveryNoteCommentNameFromId = exports.getDeliveryNoteCommentId = exports.allDeliveryNoteCommentsItems = exports.allDeliveryNoteComments = void 0;
const utils_1 = require("@loadsure/utils");
const deliveryNoteComments_class_1 = __importDefault(require("./deliveryNoteComments.class"));
const deliveryNoteComment_json_1 = __importDefault(require("./deliveryNoteComment.json"));
let noteComments;
function allDeliveryNoteComments() {
    if (!noteComments) {
        noteComments = deliveryNoteComment_json_1.default
            .map((data) => new deliveryNoteComments_class_1.default(data.id, data.index, data.name))
            .sort((a, b) => a.index - b.index);
    }
    return noteComments;
}
exports.allDeliveryNoteComments = allDeliveryNoteComments;
function allDeliveryNoteCommentsItems() {
    return allDeliveryNoteComments().map((noteComment) => new utils_1.Item(noteComment.id, noteComment.name));
}
exports.allDeliveryNoteCommentsItems = allDeliveryNoteCommentsItems;
function getDeliveryNoteCommentId(id) {
    return allDeliveryNoteComments().find((noteComment) => noteComment.id === id);
}
exports.getDeliveryNoteCommentId = getDeliveryNoteCommentId;
function getDeliveryNoteCommentNameFromId(id) {
    var _a;
    return (_a = allDeliveryNoteComments().find((noteComment) => noteComment.id === id)) === null || _a === void 0 ? void 0 : _a.name;
}
exports.getDeliveryNoteCommentNameFromId = getDeliveryNoteCommentNameFromId;
exports.default = deliveryNoteComments_class_1.default;
//# sourceMappingURL=index.js.map